/** @format */

import { Modal, Select, Spin, Typography } from "antd";
import { isEmpty } from "lodash";
import qs from "query-string";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useCountdown } from "usehooks-ts";
import axios from "../lib/axios";
import { useGeneralState } from "../state/useGeneralState";
import { authMethod } from "../lib/set_payment_header";
import { PaymentOnlyMethod } from "./PaymentMethods";
import axiosInstance from "../lib/axios";
import { useSelector } from 'react-redux';

const { Text } = Typography;

function MobileMoney({
    country,
    currency,
    reference,
    metadata,
    merchantId,
    customerEmail,
    customerName,
    amount,
    description,
    onPaymentSuccess,
    merchantDetails,
    selectedMethod,
    onFeesFetchSuccess,
    onTotalAmountChange,
    fees,
}) {
    const [pageStep, setPageStep] = useState(1);
    const [selectedProvider, setSelectedProvider] = useState();
    const [account, setAccount] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const { monoUrl } = useGeneralState();
    const { transactionBaseUrl, method } = useGeneralState();
    const [visible, setVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState(
        "Please give us sometime to confirm this transaction"
    );
    const [paymentResult, setPaymentResult] = useState();

    const correctedPhone1 = `${phoneNumber}`.replace("+", "");

    const correctedPhone2 = correctedPhone1;

    // const paidAmounts = useSelector(state => state.payment.paidAmounts);
    const paymentComments = useSelector(state => state.payment.paymentComments);

    const handleOk = () => {
        confirmPaymentAction(() => {});
    };

    const handleCancel = () => {
        if (window && window?.parent) {
            const query = qs.parse(window.location.search);
            window?.parent.postMessage({ name: "success" }, query?.origin);
        }
    };

    const validatePhone = useMutation(() => {
        return fetchNoValidation();
    });

    const fetchNoValidation = async () => {
        const result = await axios.get(
            `${monoUrl}accounts/validate/${
                country?.alpha2Code
            }/${correctedPhone2}/${
                selectedProvider?.bank_code
            }/${"external"}?is_xcel_sdk=true`,
            {
                headers: {
                    ...(await authMethod({})),
                },
            }
        );
        return result;
    };

    const makePaymentWithHeaders = async () => {
        const resultVal = JSON.parse(description);

        const keys = {};
        const comments = {};

        Object.keys(resultVal).map((i) => {
            if (Number(resultVal[i]?.amount) <= 0) {
                return;
            }
            keys[i] = Number(resultVal[i]?.amount);
            comments[i] = resultVal[i]?.comment || "";
        });

        const postBody = {
            channel: "momo",
            country: country?.alpha2Code, // source country
            user_id: merchantId, // set to merchant id
            to_acct: merchantId, // set to merchant id
            from_acct: correctedPhone2,
            currency: currency.code, // source currency
            to_provider_code: selectedProvider?.bank_code,
            from_provider_code: selectedProvider?.bank_code,
            account_name: account?.name,
            description: "Payment through Xcel sdk",
            amount: (parseInt(amount) - parseInt(fees)).toString(),
            type: "paygate_momo_pay",
            elevy_fee: "0", // set to zero
            transaction_fee: fees.toString(), // set to zero
            client_transaction_id: "", // set to empty string
            account_id: "", // set to empty string
            credit_data: {
                merchant_id: merchantId,
                reference: reference,
                customerName: account?.name,
                customerEmail,
                paymentType: PaymentOnlyMethod.momo,
                alpha2CountryCode: country?.alpha2Code,
                description: JSON.stringify(keys),
                // description: JSON.stringify(paidAmounts),
                comments: paymentComments,
                metadata: metadata ? JSON.parse(metadata) : {},
                is_giving: merchantDetails?.ent_type === "RELIGIOUS",
            },
        };
        const result = await axios.post(
            `${monoUrl}transactions/momo-pay?is_xcel_sdk=true`,
            postBody,
            {
                headers: {
                    ...(await authMethod(postBody)),
                },
            }
        );

        return result;
    };

    const makePayment = useMutation(() => {
        return makePaymentWithHeaders();
    });

    const confirmPaymentWithHeaders = async () => {
        const result = await await axios.get(
            `${monoUrl}transactions/verify-momo-payment/${paymentResult?.transaction_id}/${country?.alpha2Code}?is_xcel_sdk=true`,
            {
                headers: {
                    ...(await authMethod({})),
                },
            }
        );

        return result;
    };

    const confirmPayment = useMutation(() => {
        return confirmPaymentWithHeaders();
    });

    const fetchMnos = async () => {
        const result = await axios.get(
            `${monoUrl}accounts/momo-mnos/${country?.alpha2Code}`,
            {
                headers: {
                    ...(await authMethod({})),
                },
            }
        );
        return result;
    };

    const { data: monos } = useQuery(["bank-list", country?.alpha2Code], () => {
        return fetchMnos();
    });
    const providers = (monos?.data?.data ?? [])?.map((i) => i).flat();

    const validatePhoneNumber = async () => {
        try {
            if (isEmpty(selectedProvider?.bank_name)) return;

            const result = await validatePhone.mutateAsync();
            const data = result.data;

            if (data?.success) {
                setAccount(data?.data);
                return;
            }

            toast.error(data?.message ?? "An error occured");
        } catch (error) {
            toast.error(error?.response?.data?.message ?? "An error occured");
        }
    };

    const makePaymentAction = async () => {
        if (isEmpty(selectedProvider?.bank_name)) return;

        if (isEmpty(account)) {
            toast.error("Please enter a valid phone number");
            return;
        }

        try {
            const makePaymentResult = await makePayment.mutateAsync();
            setPaymentResult(makePaymentResult.data?.data);
            setPageStep(2);
        } catch (e) {
            toast.error(e?.response?.data?.message ?? "An error occured");
        }
    };

    const error2 = () => {
        setCountdown(false);
        stopCountdown();
        setErrorMessage(`Unfortunately, we are unable to confirm the status of this transaction at this time.
    Please be rest assured that we will notify you as soon as we can.`);
    };

    const error1 = () => {
        resetCountdown();
        startCountdown();

        setCountdown(true);
        setErrorMessage("Please give us sometime to confirm this transaction");
        // 291234567
        setVisible(true);
    };

    const callPaymentIntent = async () => {
        const resultVal = JSON.parse(description);

        const keys = {};
        const comments = {};

        Object.keys(resultVal).map((i) => {
            if (Number(resultVal[i]?.amount) <= 0) {
                return;
            }
            keys[i] = Number(resultVal[i]?.amount);
            comments[i] = resultVal[i]?.comment || "";
        });
        try {
            const result = await axios.post(
                `${transactionBaseUrl}stripe/payment-intent?amount=${Number(
                    amount
                ).toFixed(3)}&currency=${currency.code}`,
                {
                    merchant_id: merchantId,
                    reference: reference,
                    customerName: account?.name,
                    customerEmail,
                    paymentType: PaymentOnlyMethod.momo,
                    alpha2CountryCode: country?.alpha2Code,
                    description: JSON.stringify(keys),
                    comments,
                }
            );

            const data = result.data;

            if (data?.error?.message) {
                toast.warning(data?.error?.message?.raw?.message);
                return;
            }
        } catch (e) {
            
        }
    };

    const confirmPaymentAction = async (error) => {
        if (isEmpty(selectedProvider?.bank_name)) return;

        try {
            const val = await confirmPayment.mutateAsync();

            if (!isEmpty(val.data?.data)) {
                if (val?.data?.data?.status === "success") {
                    // callPaymentIntent();
                    onPaymentSuccess();
                } else {
                    error();
                }
            } else {
                error();
            }
        } catch (e) {
            error();
        }
    };

    const fetchProductFees = async () => {
        const products = JSON.parse(description);
        const selectedProducts = [];

        Object.keys(products).map((i) => {
            if (Number(products[i]?.amount) <= 0) {
                return;
            }
            selectedProducts.push({
                amount: products[i]?.amount,
                product_id: i,
            });
        });

        let payload = {
            products: selectedProducts,
            payment_option: selectedMethod,
            mno: selectedProvider?.bank_name,
        };
        const result = await axiosInstance.post(
            `${transactionBaseUrl}merchant/charge-customer/${merchantDetails?.merchant_id}`,
            payload
        );

        const productDetails = result.data.data?.productDetails;
        let fees = productDetails.reduce((acc, curr) => acc + curr.fee, 0);
        onFeesFetchSuccess(fees);
        onTotalAmountChange(result.data.data?.totalAmount);
        return result?.data?.data;
    };

    const [countdown, setCountdown] = useState(false);

    const [count, { startCountdown, stopCountdown, resetCountdown }] =
        useCountdown({
            countStart: 60 * 1,
            intervalMs: 1000,
        });

    const minutes = Math.floor(count / 60);
    const seconds = count % 60;

    useEffect(() => {
        if (countdown && count === 0) {
            confirmPaymentAction(error2);
        }
    }, [count, countdown]);

    useEffect(() => {
        fetchProductFees();
    }, [selectedProvider]);

    if (pageStep === 1) {
        return (
            <div className="payment-section m-auto mt-12 p-5">
                <h3>Pay with Mobile Money</h3>
                <p className="text-gray-400">
                    Enter your details below to complete this transaction
                </p>
                <div className="my-7">
                    <div className="flex flex-col gap-3">
                        <Text className="font-bold text-[#031339]">
                            Select Provider
                        </Text>

                        <Select
                            onSelect={(e) => {
                                setSelectedProvider(providers[e]);
                            }}
                            defaultValue={selectedProvider?.bank_name}
                            className="select-before"
                            placeholder="Select Provider">
                            {providers.map((i, index) => {
                                return (
                                    <Select.Option key={index} value={index}>
                                        {i?.bank_name}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </div>
                </div>
                <div className="my-7">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        for="username">
                        Mobile Number
                    </label>
                    <div className="flex flex-wrap -mx-3 mb-2">
                        {/* <div className="w-1/4 px-3 mb-6 md:mb-0">
                            <select
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                name="banks"
                                id="banks">
                                <option value={country.callingCodes[0]}>
                                    +{country.callingCodes[0]}
                                </option>
                            </select>
                        </div> */}
                        <div className="w-full px-3 mb-6 md:mb-0">
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="usernamexx"
                                type="text"
                                placeholder="Phone Number"
                                onChange={(e) => {
                                    setPhoneNumber(e.target.value);
                                    setAccount(undefined);
                                }}
                            />
                        </div>
                    </div>

                    {account && (
                        <p className="text-[#0095FF] text-xs italic float-right flex pt-2 mb-3 -top-2 items-center">
                            <span>
                                {account?.name ?? ""}{" "}
                                {isEmpty(account?.name ?? "") &&
                                    correctedPhone2}
                            </span>
                            <span className="ml-2 text-center mt-[1.2px]">
                                <img src="./images/green-check.svg" alt="" />
                            </span>
                        </p>
                    )}
                </div>

                <div className="my-8 flex flex-col gap-4 w-full">
                    <button
                        className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                        type="button"
                        disabled={
                            makePayment.isLoading || validatePhone.isLoading
                        }
                        onClick={async () => {
                            if (isEmpty(account)) {
                                validatePhoneNumber();
                            } else {
                                makePaymentAction();
                            }
                        }}>
                        {makePayment.isLoading || validatePhone.isLoading
                            ? "Loading..."
                            : "Proceed"}{" "}
                        <span>
                            {(makePayment.isLoading ||
                                validatePhone.isLoading) && <Spin />}
                        </span>
                    </button>
                </div>
            </div>
        );
    } else if (pageStep === 2) {
        return (
            <div className="payment-section m-auto mt-12 p-5">
                <h3>Pay with Mobile Money</h3>
                <p className="text-gray-400">
                    Complete this transaction using your mobile device and click
                    on the button below to confirm
                </p>

                <div className="my-10">
                    <button
                        className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                        type="button"
                        onClick={() => confirmPaymentAction(error1)}>
                        {confirmPayment.isLoading
                            ? "Confirming Payment..."
                            : "I have made this payment"}{" "}
                        <span>{confirmPayment.isLoading && <Spin />}</span>
                    </button>
                </div>

                <Modal
                    title="Confirming Transaction"
                    visible={visible}
                    onOk={handleOk}
                    closeIcon={
                        <div
                            className="flex justify-center items-center"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setVisible(false);
                                setCountdown(false);
                                stopCountdown();
                                setErrorMessage(
                                    "Please give us sometime to confirm this transaction"
                                );
                            }}>
                            <span className="text-black text-md font-light">
                                x
                            </span>
                        </div>
                    }
                    okText="Check Again"
                    cancelText="Close Payment And Wait For Feedback"
                    okButtonProps={{ style: { backgroundColor: "#0095FF" } }}
                    onCancel={handleCancel}>
                    <div className="flex flex-row gap-2">
                        {countdown && count > 0 && <Spin />}

                        <p>{errorMessage}</p>

                        {countdown && (
                            <span>
                                {count < 60
                                    ? `${seconds}s left`
                                    : `${minutes}:${
                                          seconds < 10 ? "0" : ""
                                      }${seconds} mins`}
                            </span>
                        )}
                    </div>
                </Modal>
            </div>
        );
    } else {
        return null;
    }
}
export default MobileMoney;
